import { Gift } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { LucideIcon } from '@/src/components/LucideIcon';
import { ReadMoreText } from '@/src/components/features/property/lib/ReadMoreText';
import { specialOfferBody, specialOfferCard, specialOfferHeading } from './specialOfferCard.styles';

type SpecialOfferCardProps = {
  description: string;
};

export function SpecialOfferCard({ description }: SpecialOfferCardProps) {
  const t = useTranslations('hdp');
  return (
    <div className={specialOfferCard}>
      <div className={specialOfferHeading}>
        <LucideIcon icon={Gift} size="sm" />
        {t('specialOffer')}
      </div>
      <div className={specialOfferBody}>
        <ReadMoreText
          controlsId="cost-and-fees-special-offer-card"
          content={description}
          maxTruncatedLength={80}
          readMoreText={t('readMore')}
          readLessText={t('readLess')}
        />
      </div>
    </div>
  );
}
